import(/* webpackMode: "eager" */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\app\\college-admission\\page.tsx");
